import { REDIRECT_PATH_PARAM } from '../config/constants';
import { USER_ROLES_MAP } from 'utils/constants';
import { LOGIN_URL_PARAMS_TO_FORWARD } from './constants';

const LOGIN_PATH = '/login';
const NON_REDIRECT_PATHS = ['/organization/home', '/organization-admin/home', '/'];

export const getLoginPath = (window) => {
  if (NON_REDIRECT_PATHS.indexOf(window.location.pathname) !== -1) return LOGIN_PATH;

  const redirectQueryParams = [
    LOGIN_PATH,
    '?',
    new URLSearchParams({ [REDIRECT_PATH_PARAM]: window.location.pathname }).toString(),
  ].join('');

  const params = new URLSearchParams(window.location.search);
  const queryString = getLoginRedirectQueryString({
    params,
    keepRedirect: false,
  }).substring(1);

  if (queryString === '') {
    return redirectQueryParams;
  }

  return `${redirectQueryParams}&${queryString}`;
};

const pathIsSuperAdminRoute = (path) => /^\/admin(\/|$)/.test(path);

const allowableRedirect = (redirectPath, user) => {
  if (!redirectPath) return false;
  if (user.isSuperAdmin) return true;
  return !pathIsSuperAdminRoute(redirectPath);
};

const getDefaultRedirect = ({ params, useCurrentPath = false }) => {
  const originalRedirect = '/organization/home';
  const currentPath = window.location.pathname;
  if (params.get(REDIRECT_PATH_PARAM)) return;

  const path = useCurrentPath && currentPath !== '/' ? currentPath : originalRedirect;

  const queryString = getLoginRedirectQueryString({ params, keepRedirect: false });
  return `${path}${queryString}`;
};

export const getRedirectUrl = ({ redirectInput, useCurrentPath }) => {
  const { user, window } = redirectInput;

  const params = new URLSearchParams(window.location.search);
  const redirectPath = params.get(REDIRECT_PATH_PARAM);
  if (allowableRedirect(redirectPath, user)) {
    const action = redirectPath + getLoginRedirectQueryString({ params, keepRedirect: false });
    return action;
  } else {
    return getDefaultRedirect({ params, useCurrentPath });
  }
};

export const getLoginRedirectQueryString = ({ params, keepRedirect = true }) => {
  const queryStringCreator = new URLSearchParams();
  const loginUrlParamsToForward = [...LOGIN_URL_PARAMS_TO_FORWARD];

  if (keepRedirect) {
    loginUrlParamsToForward.push(REDIRECT_PATH_PARAM);
  }

  loginUrlParamsToForward.forEach((paramName) => {
    const value = params.get(paramName);
    if (typeof value !== 'string') return;
    queryStringCreator.append(paramName, value);
  });

  const queryString = queryStringCreator.toString();

  if (queryString === '') return '';

  return `?${queryString}`;
};

export const REFRESH_TOKEN_JWT_KEY = 'MeeOppJWTRefreshToken';
export const ACCESS_TOKEN_JWT_KEY = 'MeeOppJWT';

const MEEOPP_EVENT_PREFIX = 'meeopp-';
export const TOKEN_SAVED_ON_STORAGE_EVENT_NAME = `${MEEOPP_EVENT_PREFIX}tokenSavedOnStorage`;
export const saveToken = ({ accessToken, refreshToken }) => {
  if (accessToken) localStorage.setItem(ACCESS_TOKEN_JWT_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_JWT_KEY, refreshToken);
  window.dispatchEvent(new Event(TOKEN_SAVED_ON_STORAGE_EVENT_NAME));
};

export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_JWT_KEY);
};

export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_JWT_KEY);
};

export const hasRoleAccess = (user, roleRequired) =>
  user.roles.includes(USER_ROLES_MAP[roleRequired]);
